/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_SET_TAXES_ITEM = {
  id: 'sub_nav_0',
  screenId: 'tax-set-taxes',
  label: 'Impuestos',
  description: 'Alta y edición de tipos de impuesto del sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Definís los impuestos que usa el sistema en facturas, percepciones, retenciones y artículos (IVA, IIBB, sellos, etc.). Cada impuesto puede tener varias alícuotas y vincularse con códigos AFIP.',
      },
      {
        title: 'Paso 1 — Ver el listado',
        bullets: [
          'Interruptor «Solo activos» — activo por defecto.',
          'Columnas: ID, Descripción, Concepto factura, Tipo AFIP, Ret. cobro (permite retención al cobrar), Activo.',
          'Podés exportar la lista. Tocá una fila para editar.',
        ],
      },
      {
        title: 'Paso 2 — Nuevo impuesto',
        fields: [
          { label: 'Descripción', description: 'Nombre interno (ej. «IVA 21%», «Percepción IIBB CABA»). Obligatoria.' },
          {
            label: 'Concepto de factura',
            description: 'Código AFIP del concepto tributario en comprobantes electrónicos. Opcional al crear.',
          },
          { label: 'Tipo AFIP', description: 'Clasificación oficial del impuesto en AFIP. Opcional.' },
          {
            label: 'Permite retención al cobrar',
            description: 'Marcá si este impuesto puede aplicarse como retención/percepción al registrar un cobro.',
          },
        ],
        paragraphs: ['Botón + → «Crear». El impuesto queda activo.'],
      },
      {
        title: 'Paso 3 — Editar o desactivar',
        bullets: [
          'Podés cambiar descripción, conceptos AFIP, si permite retención al cobrar y si está activo.',
          '«Desactivar» — deja de usarse en nuevas operaciones (pide confirmación).',
        ],
      },
    ],
  },
}
